import { IPageParam } from '../../types/common';

export interface IOperationLogParams extends IPageParam {
  /** 模块名称 */
  module?: string;
  /** 公司ID */
  companyId?: number;
  /** 公司名称 */
  companyName?: string;
  /** 用户名 */
  username?: string;
  /** 操作名称 */
  operation?: string;
  /** 开始时间 */
  startTime?: string;
  /** 结束时间 */
  endTime?: string;
  /** 状态|成功:SUCCESS|失败：FAIL */
  status?: EOperationLogStatus;
}
export interface IOperationLogItem {
  /** 主键 */
  id: number;
  /** 设备编号 */
  deviceNo: string;
  /** 公司ID */
  companyId: number;
  /** 公司名称 */
  companyName: string;
  /** 代理ID */
  agentId: number;
  /** 代理名称 */
  agentName: string;
  /** 服务ID */
  serverId: number;
  /** 服务名称 */
  serverName: string;
  /** 小程序ID */
  miniAppId: string;
  /** 用户名 */
  username: string;
  /** 用户ID */
  userId: number;
  /** IP地址 */
  ipAddress: string;
  /** IP 归属地 */
  ipSource: string;
  /** 操作描述 */
  description: string;
  /** 浏览器信息 */
  browser: string;
  /** 操作系统 */
  os: string;
  /** 请求耗时（毫秒） */
  duration: number;
  /** 操作时间 */
  operationTime: string;
  /** 请求路径 */
  requestPath: string;
  /** 状态|成功:SUCCESS|失败：FAIL */
  status: EOperationLogStatus;
  /** 模块名称 */
  module: string;
  /** 操作名称 */
  operation: string;
  /** 请求数据 */
  requestData: string;
  /** 返回数据 */
  responseData: string;
  /** 创建时间 */
  createTime: string;
  /** 异常信息 */
  exceptionMessage: string;
}

/** 操作状态 */
export enum EOperationLogStatus {
  /** 成功 */
  SUCCESS = 'SUCCESS',
  /** 失败 */
  FAIL = 'FAIL',
}

export const operationLogStatusConfig = {
  [EOperationLogStatus.SUCCESS]: '成功',
  [EOperationLogStatus.FAIL]: '失败',
};

export const operationLogStatusStyle = {
  [EOperationLogStatus.SUCCESS]: 'success',
  [EOperationLogStatus.FAIL]: 'danger',
};